{
  "appointment": {
    "CONFIRMATION_NUMBER": "확인 번호",
    "APPOINTMENT_ID": "예약 ID",
    "APPOINTMENT_DATE": "예약 날짜",
    "APPOINTMENT_TIME": "예약 시간",
    "APPOINTMENT_TIMEZONE": "시간대",
    "APPOINTMENT_TYPE": "예약 유형",
    "SCHEDULED_DURATION": "예약 소요 시간(분)",
    "STATUS": "상태",
    "ARRIVAL_DATE": "도착 날짜",
    "ARRIVAL_TIME": "도착 시간",
    "DEPARTURE_DATE": "출발 날짜",
    "DEPARTURE_TIME": "출발 시간",
    "DWELL_TIME": "체류 시간(분)",
    "ON_TIME": "정시 여부(분)",
    "IN_PROGRESS_DATE": "진행 시작 날짜",
    "IN_PROGRESS_TIME": "진행 시작 시간",
    "WAIT_TIME": "대기 시간(분)",
    "PROCESSING_TIME": "처리 시간(분)",
    "WAREHOUSE": "창고",
    "DOCK": "도크",
    "LOAD_TYPE": "화물 유형",
    "LOAD_TYPE_DIRECTION": "방향",
    "RESCHEDULE_COUNT": "일정 변경 횟수",
    "CREATED_BY": "생성자",
    "CREATOR_TYPE": "생성자 유형",
    "CREATION_DATE": "생성 날짜",
    "LAST_UPDATED_BY": "최종 수정자",
    "LAST_UPDATE_DATE": "최종 수정 날짜",
    "LAST_UPDATE_TIME": "최종 수정 시간",
    "CARRIER_COMPANY": "운송 회사",
    "CONTACT_NAME": "담당자 이름",
    "CONTACT_EMAIL": "담당자 이메일",
    "CONTACT_PHONE": "담당자 전화번호",
    "NOTES": "메모",
    "TAGS": "태그",
    "CUSTOM_FIELDS": "사용자 지정 필드",
    "EXTERNAL_VALIDATION_STATUS": "외부 검증 상태",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "외부 검증 오류 메시지",
    "CheckOut": "체크아웃",
    "CheckInAdditionalAssetDetails": "체크인 추가 자산 세부 정보",
    "InboundClaim": "입고 클레임",
    "OutboundClaim": "출고 클레임",
    "BookLoadType": "예약 화물 유형",
    "AssetContainerDetails": "자산 컨테이너 세부 정보",
    "AppointmentCompleted": "예약 완료"
  },
  "assetVisit": {
    "id": "방문 ID",
    "appointmentId": "예약 ID",
    "checkInDate": "체크인 날짜/시간",
    "checkOutDate": "체크아웃 날짜/시간",
    "carrier": "운송사",
    "warehouseName": "창고",
    "currentStatus": "상태",
    "licensePlate": "번호판",
    "visitType": "방문 유형",
    "dotNumber": "DOT 번호",
    "phone": "전화번호",
    "isPlanned": "예정됨",
    "driverNotes": "운전자 메모",
    "checkInAcknowledged": "체크인 확인됨",
    "firstName": "신원 확인 이름",
    "lastName": "신원 확인 성",
    "birthdate": "신원 확인 생년월일",
    "idValidationEmail": "신원 확인 이메일",
    "idValidationPhone": "신원 확인 전화번호"
  }
}
